import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import DocumentTitle from "react-document-title";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate } from "react-router-dom";

export default () => {

  const moduleName = `auth/login`;
  const navigate = useNavigate()
  const page = `ورود به سامانه`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);

  const handleClick = () => {
    dispatch(actions.store(moduleName));
    setSubmitted(true)
  };

  useEffect( () => {
     if(localStorage.getItem("token") != null){
      navigate("/dashboard");
     }
  }, [])

  useEffect(() => {
    if (submitted) {
      if (
        appReducer.auth_login_store != undefined &&
        appReducer.auth_login_store.error == false
      ) {
        let result = appReducer.auth_login_store.data;
        if (result.access_token != undefined) {
          localStorage.setItem("token", result.access_token);
          if (result.user.role_users.length > 0) {
            navigate("/dashboard");
          }
        }
      }
    }
  }, [appReducer.auth_login_store]);

  return (
    <DocumentTitle title={page}>
      <div className="container mx-auto max-w-lg py-16">
        <div className=" bg-white shadow-sm border border-neutral-200 flex rounded-md flex-col space-y-5 py-5">
          <div className=" flex border-b-4 pb-5 border-dashed px-5 justify-between w-full items-center">
            <h3 className="font-bold text-xl">ورود به پنل </h3>
            <svg className=" flex-shrink-0 size-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z" stroke="#1C274C" strokeWidth="1.5"></path> <path d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path> </g></svg>
          </div>
          <Template.Form >
            <Template.Input
              name="mobile"
              className="ltr"
              placeholder="موبایل را وارد نمایید"
              type="text"
              label="موبایل"
            />
            <Template.Input
              name="password"
              className="ltr"
              placeholder="رمزعبور را وارد نمایید"
              type="password"
              label="رمزعبور"
            />
            <Template.Button
              label="ورود"
              background="bg-black text-white"
              onClick={handleClick}
              size={"lg"}
              blocked={true}
            />
          </Template.Form>
        </div>
      </div>
    </DocumentTitle>
  );
};
